import React, { Component } from 'react';

class Select extends Component {
  constructor(...args) {
    super(...args);
    this.state = { empty: true };
  }

  onChange = (e) => {
    this.props.onChange && this.props.onChange(e);
    this.setState({ empty: e.target.value === '' });
  };

  onClick = (e) => {
    this.props.onClick && this.props.onClick(e);
    this.setState({ empty: false });
  };

  onBlur = (e) => {
    this.props.onBlur && this.props.onBlur(e);
    this.setState({ empty: this.props.value === '' });
  };

  render() {
    const { children, className, ...props } = this.props;

    return (
      <select
        {...props}
        className={`${className} ${
          !props.value && this.state.empty ? 'placeholder' : ''
        }`}
        onChange={this.onChange}
        onClick={this.onClick}
        onBlur={this.onBlur}
      >
        {children}
      </select>
    );
  }
}

export default Select;



// WEBPACK FOOTER //
// src/components/Select.jsx